module.exports = __webpack_public_path__ + "media/images/writer/community/welcome@3x-daf493a8babe715a315f0c913c197dab.png";